// extracted by mini-css-extract-plugin
export default {"main":"_644d27659f b638d711ec","xmark":"_25716d201d","fl_img":"_9eed898bf2 b8c067ab22"};